export default "__VITE_ASSET__Cqv8nrdJ__"